

















import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import NavBar from "@/components/NavBar.vue";
import Menu from "@/views/Menu.vue";

@Component({
    components: {
        NavBar, MenuView: Menu
    },
    computed: {
        ...mapGetters({isCompany: 'isCompany', isWorker: 'isWorker', user: 'user'})
    },
    name: "App"
})
export default class App extends Vue {
    private user?: any;
    private menuOpen: boolean = false
}
